import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useAppContext } from '../context/AppContext'
import '../styles/GiftsPage.css'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'

const GiftsPage = () => {
  const { user } = useAppContext()
  const navigate = useNavigate()
  
  const [gifts, setGifts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user || !user.token) {
      navigate('/admin-login')
      return
    }
    fetchGifts()
  }, [user, navigate])

  const fetchGifts = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/admin/gifts/${user.username}`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      })
      console.log('Fetched gifts:', res.data)
      // Extract the gifts array from the response
      setGifts(res.data.gifts || [])
      setLoading(false)
    } catch (err) {
      console.error('Failed to fetch gifts:', err)
      setLoading(false)
      if (err.response && err.response.data && err.response.data.error === "Invalid or expired token") {
        navigate('/admin-login')
      }
    }
  }

  const handleBackToDashboard = () => {
    navigate('/admin')
  }

  return (
    <div className="gifts-page-container">
      <div className="gifts-header">
        <button className="back-button" onClick={handleBackToDashboard}>
          ← חזור ללוח הבקרה
        </button>
        <h1>🎁 ניהול מתנות</h1>
      </div>

      <div className="gifts-content">
        {loading ? (
          <div className="loading-section">
            <p>⏳ טוען מתנות...</p>
          </div>
        ) : gifts.length > 0 ? (
          <div className="gifts-list">
            <div className="gifts-summary">
              <div className="summary-card">
                <h3>סה"כ מתנות</h3>
                <p className="summary-number">{gifts.length}</p>
              </div>
              <div className="summary-card">
                <h3>סכום כולל</h3>
                <p className="summary-number">
                  ₪{gifts.reduce((sum, gift) => sum + (parseFloat(gift.amount) || 0), 0).toLocaleString()}
                </p>
              </div>
            </div>

            <div className="gifts-table-container">
              <table className="gifts-table">
                <thead>
                  <tr>
                    <th>שם פרטי</th>
                    <th>שם משפחה</th>
                    <th>טלפון</th>
                    <th>סכום</th>
                    <th>ברכה</th>
                  </tr>
                </thead>
                <tbody>
                  {gifts.map((gift) => (
                    <tr key={gift.id}>
                      <td>{gift.first_name}</td>
                      <td>{gift.last_name}</td>
                      <td>{gift.phone}</td>
                      <td>₪{parseFloat(gift.amount).toLocaleString()}</td>
                      <td className="greeting-cell">{gift.greeting || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="no-gifts-section">
            <div className="no-gifts-icon">🎁</div>
            <h2>אין מתנות עדיין</h2>
            <p>כאשר אורחים ישלחו מתנות, הן יופיעו כאן</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default GiftsPage
